module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "通知标题"
    },
    model: {
      value: (_vm.filters.title),
      callback: function($$v) {
        _vm.$set(_vm.filters, "title", $$v)
      },
      expression: "filters.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getNoticeList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (!_vm.comuser) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("发布通知")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.noticelist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "发布人",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "发布时间",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), (!_vm.comuser) ? _c('el-table-column', {
    attrs: {
      "label": "通知类型",
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.noticeType === '0' ? '全部企业' : "指定企业"))])]
      }
    }], null, false, 4292219793)
  }) : _vm._e(), _vm._v(" "), (_vm.comuser) ? _c('el-table-column', {
    attrs: {
      "label": "通知状态",
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.readStatus === "0") ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("未读")])]) : _c('div', [_c('span', [_vm._v("已读")])])]
      }
    }], null, false, 1992527554)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!_vm.comuser) ? _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("通知详情")]) : _vm._e(), _vm._v(" "), (!_vm.comuser) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleCompanyDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("签收详情")]) : _vm._e(), _vm._v(" "), (!_vm.comuser) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (_vm.comuser) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看通知")]) : _vm._e(), _vm._v(" "), (_vm.comuser) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleCompanyfileAdd(scope.$index, scope.row)
            }
          }
        }, [_vm._v("上传附件")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增通知信息",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.title),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "title", $$v)
      },
      expression: "addForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.content),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "content", $$v)
      },
      expression: "addForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通知类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.noticeType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "noticeType", $$v)
      },
      expression: "addForm.noticeType"
    }
  }, _vm._l((_vm.ntoptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.addForm.noticeType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "接收企业"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.enterpriseList,
      "border": "",
      "max-height": "250"
    },
    on: {
      "selection-change": _vm.handleEnterpriseSelect
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通知附件"
    }
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "/yhpczl/mgr/v1/notice/upload",
      "multiple": true,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "auto-upload": false,
      "accept": '.pdf',
      "on-success": _vm.handleAttachmentSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("选取文件")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("点击上传")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleNoticeAdd.apply(null, arguments)
      }
    }
  }, [_vm._v("发布通知")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "企业提交材料",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通知标题",
      "prop": "title"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.title))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业材料"
    }
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "/yhpczl/mgr/v1/notice/upload",
      "multiple": true,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "auto-upload": false,
      "accept": '.pdf',
      "on-success": _vm.handleAttachmentSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("选取文件")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("点击上传")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateCompanyfile.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "通知详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('h2', {
    staticClass: "base-name"
  }, [_vm._v(_vm._s(_vm.detailForm.title))]), _vm._v(" "), _c('div', {
    staticClass: "base-info-row"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("发布人：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("发布时间：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.createTime))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("通知内容：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.content))])])]), _vm._v(" "), (_vm.detailForm.fileurls.length > 0) ? _c('div', [_c('h3', [_vm._v("通知附件")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailForm.fileurls,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": "文件名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看文件")])]
      }
    }], null, false, 2718897294)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.comuser && _vm.detailForm.comfileurls.length > 0) ? _c('div', [_c('h3', [_vm._v("企业资料")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailForm.comfileurls,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": "文件名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看文件")])]
      }
    }], null, false, 2718897294)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "通知签收详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.comdetailFormVisible),
      callback: function($$v) {
        _vm.comdetailFormVisible = $$v
      },
      expression: "comdetailFormVisible"
    }
  }, [_c('h2', {
    staticClass: "base-name"
  }, [_vm._v(_vm._s(_vm.comdetailForm.title))]), _vm._v(" "), _c('div', {
    staticClass: "base-info-row"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("应签收企业数：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.comdetailForm.totalcount))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("已签收企业数：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.comdetailForm.readcount))])])]), _vm._v(" "), _c('h3', [_vm._v("企业签收情况表")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.comdetailForm.nclist,
      "border": "",
      "max-height": "250"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.readStatus === "0") ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("未读")])]) : _c('div', [_c('span', [_vm._v("已读")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "企业材料",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.readStatus === "1") ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleShowComfile(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看材料")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.comdetailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "企业资料",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.comdetailfileFormVisible),
      callback: function($$v) {
        _vm.comdetailfileFormVisible = $$v
      },
      expression: "comdetailfileFormVisible"
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("企业名称：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.comdetailfileForm.coName))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.comdetailfileForm.comfileurls,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": "文件名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看文件")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.comdetailfileFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.pdfFileName,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.pdfVisible),
      callback: function($$v) {
        _vm.pdfVisible = $$v
      },
      expression: "pdfVisible"
    }
  }, [_c('el-form', [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": _vm.pdfSrc,
      "frameborder": "0"
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-091aaef0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav/noticeManager.vue
// module id = 819
// module chunks = 2